import { services, businessInfo } from '../data/business';
import { Settings, Zap, Wifi, Wrench, Plug, Phone, ArrowRight } from 'lucide-react';

const iconMap: Record<string, any> = {
  Cabinet: Settings,
  Zap: Zap,
  Wifi: Wifi,
  Wrench: Wrench,
  Plug: Plug,
};

export default function Services() {
  return (
    <section id="services" className="section-padding bg-gray-50 relative">
      {/* Background Pattern */}
      <div className="absolute top-0 right-0 w-1/3 h-full bg-[radial-gradient(#e5e7eb_1px,transparent_1px)] [background-size:20px_20px] opacity-50 pointer-events-none"></div>

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="text-center max-w-4xl mx-auto mb-12 sm:mb-16">
          <div className="inline-block px-3 py-1 bg-white text-primary font-bold text-sm uppercase tracking-wider mb-4 sm:mb-6 border border-gray-200 shadow-sm">
            Naše Usluge
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-heading font-extrabold text-text mb-4 sm:mb-6">
            Kompletna <span className="text-primary border-b-4 border-primary">elektro rešenja</span>
          </h2>
          <p className="text-gray-800 text-lg sm:text-xl font-medium max-w-2xl mx-auto">
            Za stambene, poslovne i industrijske objekte. Specijalizovani za najzahtevnije elektro izazove.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-16">
          {services.map((service) => {
            const Icon = iconMap[service.icon] || Zap;
            
            return (
              <div 
                key={service.id} 
                className="bg-white p-6 sm:p-8 rounded shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1 border-b-4 border-transparent hover:border-primary group relative overflow-hidden active:scale-[0.98]"
              >
                <div className="absolute top-0 right-0 w-20 h-20 bg-gray-50 rounded-bl-full -mr-10 -mt-10 transition-colors group-hover:bg-red-50"></div>
                
                <div className="w-14 h-14 bg-white border-2 border-gray-100 rounded flex items-center justify-center mb-6 group-hover:border-primary group-hover:bg-primary transition-all duration-300 relative z-10 shadow-sm">
                  <Icon className="w-7 h-7 text-primary group-hover:text-white transition-colors duration-300" strokeWidth={2} />
                </div>
                
                <h3 className="text-xl font-bold text-text mb-3 group-hover:text-primary transition-colors relative z-10">
                  {service.title}
                </h3>
                <p className="text-gray-700 text-base leading-relaxed mb-4 relative z-10">
                  {service.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* CTA Banner */}
        <div className="bg-primary rounded p-8 sm:p-12 shadow-2xl relative overflow-hidden text-center md:text-left">
          {/* Decorative Lines */}
          <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-20 pointer-events-none">
            <div className="absolute top-0 left-0 w-full h-px bg-white transform rotate-12 translate-y-10"></div>
            <div className="absolute top-0 left-0 w-full h-px bg-white transform -rotate-12 translate-y-20"></div>
          </div>
          
          <div className="relative z-10 flex flex-col md:flex-row items-center justify-between gap-8">
            <div>
              <h3 className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-white mb-3">
                Potrebna vam je procena radova?
              </h3>
              <p className="text-white text-lg sm:text-xl font-medium opacity-90 max-w-2xl">
                Kontaktirajte nas za besplatne konsultacije i informacije o cenama.
              </p>
            </div>
            <a 
              href={`tel:${businessInfo.phoneClean}`}
              className="bg-white text-primary px-8 py-4 rounded font-bold text-lg sm:text-xl shadow-lg hover:bg-gray-50 active:scale-95 transition-all flex items-center gap-3 whitespace-nowrap border-2 border-white w-full sm:w-auto justify-center"
            >
              <Phone size={24} fill="currentColor" />
              {businessInfo.phone}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
